import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const LandedCostInCheckoutPage = withCompass(
  () => import("../../workspace/kl/landed-cost-checkout/Page"),
);
import BrandOrderDetailPackingSlipPrintingPage from "@faire/prototype-playground/workspace/kl/packing-slip-printing";

const FDXPCheckoutPage = lazy(() => import("../../pages/FDXPCheckoutPage"));
const FDXPCheckoutPaymentPage = lazy(
  () => import("../../pages/FDXPCheckoutPaymentPage")
);
const HomepageQ226Page = lazy(() => import("../../pages/HomepageQ226Page"));
const LoggedOutPersonalizationPage = lazy(
  () => import("../../pages/LoggedOutPersonalizationPage")
);
const HowFaireWorksPage = lazy(() => import("../../pages/HowFaireWorksPage"));
const OnboardingPage = lazy(() => import("../../pages/OnboardingPage"));

export function KevinLaiRoutes() {
  return (
    <Switch>
      <Route path="/kl/fdxp-checkout" component={FDXPCheckoutPage} />
      <Route
        path="/kl/fdxp-checkout-payment"
        component={FDXPCheckoutPaymentPage}
      />
      <Route path="/kl/homepage-q226" component={HomepageQ226Page} />
      <Route path="/kl/how-faire-works" component={HowFaireWorksPage} />
      <Route path="/kl/landed-cost-checkout" component={LandedCostInCheckoutPage} />
      <Route
        path="/kl/logged-out-personalization"
        component={LoggedOutPersonalizationPage}
      />
      <Route path="/kl/onboarding" component={OnboardingPage} />
      <Route path="/kl/packing-slip-printing" component={BrandOrderDetailPackingSlipPrintingPage} />
    </Switch>
  );
}

export const slug = "kl";
